export default {"src":"/_next/static/media/ppc.cfa04795.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};